import { GatePassageResultAlert } from '@planning/pages/GateClerk/Components/GatePassageResultAlert'
import { GateOutWarningDialogs } from '@planning/pages/GateControl/Components/GateOutWarningDialogs'
import { GateInViewStore } from '@planning/stores/gateControl/GateInViewStore'
import { observer } from 'mobx-react-lite'

interface Props {
  gateInViewStore: GateInViewStore
}
export const TruckVisitsDialogs = observer(({ gateInViewStore }: Props) => {
  return (
    <>
      <GatePassageResultAlert store={gateInViewStore.notificationStore} />
      <GateOutWarningDialogs viewStore={gateInViewStore} />
    </>
  )
})
